export function removeUndefined<T>(...args: (T | undefined | null)[]): T[] {
  return args.filter(arg => arg !== undefined && arg !== null);
}
